import { SET_TARGET_AGENT, UNSET_TARGET_AGENT } from '../actions/types';

const initialState = {
  chosenAgent: {},
  didPickAgent: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_TARGET_AGENT:
      return action.payload;
    case UNSET_TARGET_AGENT:
      return initialState;
    default:
      return state;
  }
}
